const RemoveItem = (key: string) => {
  return localStorage.removeItem(key);
};

export default RemoveItem;
